import React from 'react'
import { Link, NavLink } from 'react-router-dom';
import './Headerscss.css';

function Navbar({ isNavOpen, setIsNavOpen, togglerRef }) {
  return (
    <div className="d-none d-lg-block">
      {/* ================= NAVBAR ================= */}
<nav className="navbar navbar-expand-lg navbar-light bgnav sticky-top">
  <div className="container-fluid">

    {/* TOGGLER */}
    <button
      className="navbar-toggler"
      ref={togglerRef}
      onClick={() => setIsNavOpen(!isNavOpen)}
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    {/* LINKS */}
    <div className={`collapse navbar-collapse ${isNavOpen ? "show" : ""}`}>
      <ul className="navbar-nav mx-auto gap-4">
                   <li className="nav-item" >
                     <NavLink 
                      to="/" 
     className={({ isActive }) =>
      `nav-link ${isActive ? "active-nav" : "text-dark"}`
    }
                     onClick={() => setIsNavOpen(false)}
     >
       <b>Home</b>
       </NavLink>
                   </li>
                   {/* <li className="nav-item">
                     <Link className="nav-link text-dark"
                      to="/About"
                     onClick={() => setIsNavOpen(false)}
                      ><b>About</b></Link>
                   </li> */}
                   <li className="nav-item">
  <NavLink
    to="/About"
    className={({ isActive }) =>
      `nav-link ${isActive ? "active-nav" : "text-dark"}`
    }
    onClick={() => setIsNavOpen(false)}
  >
    <b>About</b>
  </NavLink>
</li>

                   {/* <li className="nav-item">
                     <Link className="nav-link text-dark" to="/ProductsPage"><b>ProductsDummy</b></Link>
                   </li> */}
                   <li className="nav-item">
                     <NavLink
                      to="/products"
                       className={({ isActive }) =>
      `nav-link ${isActive ? "active-nav" : "text-dark"}`
    }
                   onClick={() => setIsNavOpen(false)}
     >
       <b>Product</b>
       </NavLink>
                   </li>
                    <li className="nav-item">
                     <NavLink 
                     className={({ isActive }) =>
      `nav-link ${isActive ? "active-nav" : "text-dark"}`
    }
                     to="/coursesection"                 onClick={() => setIsNavOpen(false)}
     ><b>Courses</b></NavLink>
                   </li>
                   <li className="nav-item">
                     <NavLink 
                     className={({ isActive }) =>
      `nav-link ${isActive ? "active-nav" : "text-dark"}`
    }
                     to="/Ebooks"                 onClick={() => setIsNavOpen(false)}
     ><b>E-Books</b></NavLink>
                   </li>
                    <li className="nav-item">
                     <NavLink 
                     className={({ isActive }) =>
      `nav-link ${isActive ? "active-nav" : "text-dark"}`
    }
                    //  to="/blog"      
                      to="/Blog"  
                     onClick={() => setIsNavOpen(false)}
     ><b>Blog</b></NavLink>
                   </li>
                   <li className="nav-item">
                     <NavLink 
                     className={({ isActive }) =>
      `nav-link ${isActive ? "active-nav" : "text-dark"}`
    }
                     to="/ShopPage"
                       onClick={() => setIsNavOpen(false)}
     ><b>Shop</b></NavLink>
                   </li>
                   <li className="nav-item">
                     <NavLink 
                     className={({ isActive }) =>
      `nav-link ${isActive ? "active-nav" : "text-dark"}`
    }
                     to="/Testimonial"                 onClick={() => setIsNavOpen(false)}
     ><b>Testimonial</b></NavLink>
                   </li>
                  
                  <li className="nav-item">
                     <NavLink 
                      className={({ isActive }) =>
      `nav-link ${isActive ? "active-nav" : "text-dark"}`
    }
                     to="/Contact"                  onClick={() => setIsNavOpen(false)}
     ><b>Contact</b></NavLink>
                   </li>
                   <li className="nav-item">
                     <NavLink 
                     className={({ isActive }) =>
      `nav-link ${isActive ? "active-nav" : "text-dark"}`
    }
                     to="/faq"                 onClick={() => setIsNavOpen(false)}
     ><b>FAQ</b></NavLink>
                   </li>
                 </ul>
    </div>
  </div>
</nav>

    </div>
  )
}

export default Navbar;
